import React from 'react';
import PrimaryButton from '../../../components/shacdn/PrimaryButton';
import Logo from '@/assets/homepage/logo.svg';

const Header: React.FC = () => (
  <header className='w-full  flex items-center justify-center sticky top-0 z-30'>
    <div className='w-full max-w-[1480px]  flex items-center justify-between px-6 py-4 bg-white/40 backdrop-blur-md rounded-b-2xl shadow-md '>
      <div className='flex items-center'>
        {/* Logo Placeholder */}
        <img src={Logo} className='w-[180px]' alt='' />
      </div>
      <PrimaryButton className='max-[560px]:hidden'>Work with us</PrimaryButton>
    </div>
  </header>
);

export default Header;
